"use strict";

angular.module('rmFormBuilder', []);

require('./controller');
require('./resources');
require('./directives');
require('./routes');